/**
 * Format for displaying dates in MM/dd/yyyy format.
 * @example '01/15/2023'
 */
export const MM_DD_YYYY = 'MM/dd/yyyy';

/**
 * Format for displaying dates with month name, day, year, and time.
 * @example 'January 15, 2023, 3:30 pm'
 */
export const MMMM_D_YYYY_H_MM_A = 'MMMM d, yyyy, h:mm a';

/**
 * Format for displaying dates with abbreviated day of week, abbreviated month name, day, year, and time with 'at' separator.
 * @example 'Mon Aug 4, 2025 at 8:00AM'
 */
export const EEE_MMM_D_YYYY_AT_H_MMA = 'EEE MMM d, yyyy \'at\' h:mma';

/**
 * Format for displaying dates with full day of week, full month name, day, and year.
 * @example 'Saturday, November 25, 2020'
 */
export const EEEE_MMMM_D_YYYY = 'EEEE, MMMM d, yyyy';
